import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration.js';
let isUpdated=false

ReactDOM.render(
  <React.Fragment> 
    <App />
  </React.Fragment>,
  document.getElementById('root')
);

const configuration = {
  
  onUpdate: (registration) => {
    //console.log("registration",registration)
    if (registration && registration.waiting) {
      isUpdated = true
      document.getElementById("new-updates").style.display = "flex"
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
     
    }
  }
};

serviceWorkerRegistration.register(configuration);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
